import {
  fetchComplianceMetrics,
  fetchActualFPH,
  fetchDNCData,
  getStowWipData,
  getOcrData,
  fetchArrivedData,
  getNodeLinehaulData,
} from "../network/OverviewNetworkAPI";

export const OverviewReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_FPH_OVERVIEW":
      const { filter, dispatcher, processName, baseUrl } = action.data;
      fetchActualFPH(filter, processName, dispatcher, baseUrl);
      return state;
    case "LOAD_COMPLIANCE_OVERVIEW":
      if (action.data.processName === "scanCompliance") {
        fetchComplianceMetrics(
          action.data.filter,
          action.data.processName,
          action.data.dispatcher,
        );
      }
      if (action.data.processName === "goldilock") {
        fetchActualFPH(
          action.data.filter,
          action.data.processName,
          action.data.dispatcher,
        );
      }
      if (action.data.processName === "rolledVolume") {
        fetchComplianceMetrics(
          action.data.filter,
          action.data.processName,
          action.data.dispatcher,
        );
      }
      return state;

    case "LOAD_WIP_DATA":
      if (action.data.processName === "stowWip") {
        getStowWipData(action.data.dispatcher, action.data.selectedCycle);
      }
      return state;

    case "LOAD_OCR_DATA":
      getOcrData(action.data.dispatcher, action.data.filter[0]);
      return state;

    case "RECEIVE_STOW_WIP_DATA":
      return {
        ...state,
        wip: {
          ...state.wip,
          stowWip: {
            ...state.wip.stowWip,
            actual: action.data.value,
          },
        },
      };

    case "RECEIVE_OCR_DATA":
      return {
        ...state,
        ocr: {
          ...state.ocr,
          ontimeCompletionRisk: {
            ...state.ocr.ontimeCompletionRisk,
            value: action.data.value,
            classification: action.data.classification,
          },
        },
      };

    case "RECEIVE_FPH_DATA":
      if (action.data.metricName === "goldilock") {
        return {
          ...state,
          compliance: {
            ...state.compliance,
            goldilock: {
              ...state.compliance.goldilock,
              value: action.data.value,
            },
          },
        };
      }
      return {
        ...state,
        fph: {
          ...state.fph,
          [action.data.metricName]: {
            ...state.fph[action.data.metricName],
            actual: action.data.value,
          },
        },
      };
    case "RECEIVE_COMPLIANCE_DATA":
      return {
        ...state,
        compliance: {
          ...state.compliance,
          [action.processName]: {
            ...state.compliance[action.processName],
            value: action.data[0].metricValue,
          },
        },
      };
    case "RECEIVE_ARRIVED_DATA":
      return {
        ...state,
        tv: {
          ...state.tv,
          totalVolume: {
            ...state.tv.totalVolume,
            arrived: action.data.arrived_total_volume,
          },
        },
      };
    case "LOAD_DNC_DATA":
      fetchDNCData(action.data.filter, action.data.dispatcher);
      return state;
    case "LOAD_ARRIVED_DATA":
      fetchArrivedData(action.data.filter, action.data.dispatcher);
      return state;
    case "LOAD_NODE_LINEHAUL_DATA":
      getNodeLinehaulData(action.data.dispatcher);
      return state;
    case "RECEIVE_NODE_LINEHAUL_DATA":
      return {
        ...state,
        linehaul: {
          ...state.linehaul,
          linehaulsAtRisk: {
            ...state.linehaul.linehaulsAtRisk,
            value: action.data.lineHauls,
          },
        },
      };
    case "RECEIVE_STOW_WIP_COMPLIANCE_DATA":
      return {
        ...state,
        wip: {
          ...state.wip,
          stowWipComplianceData: {
            metricName: action.data.metricName,
            nodeID: action.data.nodeID,
            value: action.data.value,
            classification: action.data.classification,
          },
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/overview/reducers/OverviewReducer.js